<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Revenue Stream Summary</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Revenue Stream Summary Report" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarStreams/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Revenue Stream Summary</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item active">Revenue Summary</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Revenue</p>
                      <h4 class="mb-0">{{formatPrice(grandTotal)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Transactions</p>
                      <h4 class="mb-0">{{totalTransactions.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-receipt font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Agents</p>
                      <h4 class="mb-0">{{totalUniqueAgents.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-user font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Revenue Streams</p>
                      <h4 class="mb-0">{{revenueStreams.length}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-list-ul font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Report Card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h4 class="card-title mb-0">
                        Revenue Stream Performance
                      </h4>
                      <p class="text-muted mb-0 mt-1">
                        <i class="bx bx-calendar me-1"></i>
                        <span class="me-3">From: <strong>{{moment(dateFrom).format('DD/MM/YYYY')}}</strong></span>
                        <span>To: <strong>{{moment(dateTo).format('DD/MM/YYYY')}}</strong></span>
                      </p>
                      <!-- Active Filters Display -->
                      <div v-if="selectedSubCounty || selectedWard || selectedZone" class="mt-2">
                        <span class="badge bg-soft-info text-info me-2" v-if="selectedSubCounty">
                          <i class="bx bx-map me-1"></i>{{getSubCountyName(selectedSubCounty)}}
                        </span>
                        <span class="badge bg-soft-success text-success me-2" v-if="selectedWard">
                          <i class="bx bx-location-plus me-1"></i>{{getWardName(selectedWard)}}
                        </span>
                        <span class="badge bg-soft-warning text-warning" v-if="selectedZone">
                          <i class="bx bx-target-lock me-1"></i>{{getZoneName(selectedZone)}}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <button @click="refreshData" class="btn btn-sm btn-outline-primary me-2" :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i> Refresh
                      </button>
                      <div class="btn-group me-2" role="group">
                        <button @click="setDateRange('today')" class="btn btn-sm" :class="dateRangeType === 'today' ? 'btn-primary' : 'btn-outline-primary'">Today</button>
                        <button @click="setDateRange('week')" class="btn btn-sm" :class="dateRangeType === 'week' ? 'btn-primary' : 'btn-outline-primary'">Week</button>
                        <button @click="setDateRange('month')" class="btn btn-sm" :class="dateRangeType === 'month' ? 'btn-primary' : 'btn-outline-primary'">Month</button>
                        <button @click="setDateRange('year')" class="btn btn-sm" :class="dateRangeType === 'year' ? 'btn-primary' : 'btn-outline-primary'">Year</button>
                        <button @click="setDateRange('custom')" class="btn btn-sm" :class="dateRangeType === 'custom' ? 'btn-primary' : 'btn-outline-primary'">Custom</button>
                      </div>
                      <button
                          v-if="getRight('DOWNLOAD BY STREAMS REPORTS')"
                          @click="downloadCSV"
                          class="btn btn-sm btn-primary"
                          :disabled="loading || revenueStreams.length === 0"
                      >
                        <i class="bx bx-download me-1"></i> Download CSV
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Date Range & Location Filters -->
                  <div class="row mb-4">
                    <!-- Date Range Selector (Custom) -->
                    <div class="col-md-2" v-show="dateRangeType === 'custom'">
                      <label class="form-label">Date From</label>
                      <input v-model="dateFrom" class="form-control form-control-sm" type="date" :max="dateTo">
                    </div>
                    <div class="col-md-2" v-show="dateRangeType === 'custom'">
                      <label class="form-label">Date To</label>
                      <input v-model="dateTo" class="form-control form-control-sm" type="date" :min="dateFrom" :max="maxDate">
                    </div>
                    <div class="col-md-1" v-show="dateRangeType === 'custom'">
                      <label class="form-label">&nbsp;</label>
                      <button @click="getRevenueData" class="btn btn-primary btn-sm w-100">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>

                    <!-- Location Filters -->
                    <div class="col-md-3" :class="{'offset-md-5': dateRangeType !== 'custom'}">
                      <label class="form-label">Sub County</label>
                      <select v-model="selectedSubCounty" class="form-select form-select-sm" @change="onSubCountyChange">
                        <option value="">All Sub Counties</option>
                        <option v-for="sc in subCounties" :key="sc.id" :value="sc.id">
                          {{sc.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Ward</label>
                      <select v-model="selectedWard" class="form-select form-select-sm" @change="onWardChange" :disabled="!selectedSubCounty">
                        <option value="">All Wards</option>
                        <option v-for="ward in filteredWards" :key="ward.id" :value="ward.id">
                          {{ward.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Zone</label>
                      <select v-model="selectedZone" class="form-select form-select-sm" @change="onZoneChange" :disabled="!selectedWard">
                        <option value="">All Zones</option>
                        <option v-for="zone in filteredZones" :key="zone.id" :value="zone.id">
                          {{zone.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-1" v-if="selectedSubCounty || selectedWard || selectedZone">
                      <label class="form-label">&nbsp;</label>
                      <button @click="clearLocationFilters" class="btn btn-outline-secondary btn-sm w-100" title="Clear filters">
                        <i class="bx bx-x"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Filter Section -->
                  <div class="row mb-3" v-if="!loading && revenueStreams.length > 0">
                    <div class="col-md-4">
                      <div class="input-group input-group-sm">
                        <span class="input-group-text">
                          <i class="bx bx-search"></i>
                        </span>
                        <input
                            v-model="searchQuery"
                            type="text"
                            class="form-control"
                            placeholder="Search revenue streams..."
                            @input="handleSearch"
                        >
                        <button
                            v-if="searchQuery"
                            class="btn btn-outline-secondary"
                            type="button"
                            @click="clearSearch"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-8 text-md-end">
                      <small class="text-muted">
                        Showing {{filteredAndSortedStreams.length}} of {{revenueStreams.length}} streams
                      </small>
                    </div>
                  </div>

                  <!-- Revenue Stream Table -->
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0" v-if="!loading && revenueStreams.length > 0" id="revenueTable">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 5%">#</th>
                        <th
                            style="width: 35%; cursor: pointer;"
                            @click="sortBy('revenueStream')"
                            class="sortable-header"
                        >
                          Revenue Stream
                          <i class="bx ms-1" :class="getSortIcon('revenueStream')"></i>
                        </th>
                        <th
                            class="text-center sortable-header"
                            style="width: 20%; cursor: pointer;"
                            @click="sortBy('totalTransactions')"
                        >
                          Total Transactions
                          <i class="bx ms-1" :class="getSortIcon('totalTransactions')"></i>
                        </th>
                        <th
                            class="text-center sortable-header"
                            style="width: 15%; cursor: pointer;"
                            @click="sortBy('totalAgents')"
                        >
                          Total Agents
                          <i class="bx ms-1" :class="getSortIcon('totalAgents')"></i>
                        </th>
                        <th
                            class="text-end sortable-header"
                            style="width: 20%; cursor: pointer;"
                            @click="sortBy('amountCollected')"
                        >
                          Amount Collected
                          <i class="bx ms-1" :class="getSortIcon('amountCollected')"></i>
                        </th>
                        <th class="text-center" style="width: 5%">Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(stream, index) in paginatedStreams" :key="stream.incomeTypePrefix"
                          :class="{'table-warning': stream.revenueStream === 'Uninvoiced Payments'}">
                        <td>{{(currentPage - 1) * itemsPerPage + index + 1}}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-3">
                                  <span class="avatar-title rounded-circle"
                                        :class="getStreamColor(stream.revenueStream)">
                                    <i :class="getStreamIcon(stream.revenueStream)"></i>
                                  </span>
                            </div>
                            <div>
                              <h6 class="mb-0 text-uppercase">{{stream.revenueStream}}</h6>
                              <small class="text-muted">{{stream.incomeTypePrefix || 'N/A'}}</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                              <span class="badge bg-soft-primary text-primary">
                                {{Number(stream.totalTransactions).toLocaleString()}}
                              </span>
                        </td>
                        <td class="text-center">
                              <span class="badge bg-soft-info text-info">
                                {{Number(stream.totalAgents).toLocaleString()}}
                              </span>
                        </td>
                        <td class="text-end">
                          <strong>{{formatPrice(stream.amountCollected)}}</strong>
                        </td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary" @click="viewDetails('reports-streams-details',stream,stream.amountCollected)">
                            <i class="bx bx-show me-1"></i>View
                          </button>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-light">
                      <tr>
                        <td colspan="2" class="text-end fw-bold">
                          <span v-if="searchQuery || selectedSubCounty || selectedWard || selectedZone" class="text-muted me-2">(Filtered)</span>
                          TOTALS
                        </td>
                        <td class="text-center">
                          <strong class="text-primary">{{Number(filteredTotalTransactions).toLocaleString()}}</strong>
                        </td>
                        <td class="text-center">
                          <strong class="text-info">{{Number(filteredTotalAgents).toLocaleString()}}</strong>
                        </td>
                        <td class="text-end">
                          <h5 class="mb-0 text-success">{{formatPrice(filteredGrandTotal)}}</h5>
                        </td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Pagination -->
                    <div v-if="!loading && totalPages > 1" class="row mt-3">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{(currentPage - 1) * itemsPerPage + 1}} to
                          {{Math.min(currentPage * itemsPerPage, filteredAndSortedStreams.length)}}
                          of {{filteredAndSortedStreams.length}} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination pagination-rounded">
                            <li class="paginate_button page-item previous" :class="{disabled: currentPage === 1}">
                              <a href="#" @click.prevent="currentPage = 1" class="page-link">
                                <i class="mdi mdi-chevron-double-left"></i>
                              </a>
                            </li>
                            <li class="paginate_button page-item previous" :class="{disabled: currentPage === 1}">
                              <a href="#" @click.prevent="currentPage > 1 && currentPage--" class="page-link">
                                <i class="mdi mdi-chevron-left"></i>
                              </a>
                            </li>

                            <li v-for="page in displayedPages" :key="page"
                                class="paginate_button page-item"
                                :class="{active: currentPage === page, disabled: page === '...'}">
                              <a href="#" @click.prevent="page !== '...' && (currentPage = page)" class="page-link">
                                {{page}}
                              </a>
                            </li>

                            <li class="paginate_button page-item next" :class="{disabled: currentPage === totalPages}">
                              <a href="#" @click.prevent="currentPage < totalPages && currentPage++" class="page-link">
                                <i class="mdi mdi-chevron-right"></i>
                              </a>
                            </li>
                            <li class="paginate_button page-item next" :class="{disabled: currentPage === totalPages}">
                              <a href="#" @click.prevent="currentPage = totalPages" class="page-link">
                                <i class="mdi mdi-chevron-double-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0">Loading revenue summary...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && revenueStreams.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Revenue Data Available</h5>
                      <p class="text-muted">No revenue streams found for the selected criteria.</p>
                      <button v-if="selectedSubCounty || selectedWard || selectedZone" class="btn btn-sm btn-primary mt-2" @click="clearLocationFilters">
                        <i class="bx bx-refresh me-1"></i>Clear Filters and Retry
                      </button>
                    </div>

                    <!-- No Results State (after filtering) -->
                    <div v-if="!loading && revenueStreams.length > 0 && filteredAndSortedStreams.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Matching Results</h5>
                      <p class="text-muted">No revenue streams match your search criteria.</p>
                      <button class="btn btn-sm btn-primary mt-2" @click="clearSearch">
                        <i class="bx bx-x me-1"></i>Clear Search
                      </button>
                    </div>
                  </div>

                  <!-- Performance Insights -->
                  <div class="row mt-4" v-if="!loading && revenueStreams.length > 0">
                    <div class="col-12">
                      <div class="card bg-light">
                        <div class="card-body">
                          <h6 class="mb-3">Performance Insights</h6>
                          <div class="row">
                            <div class="col-md-3">
                              <small class="text-muted">Top Revenue Stream:</small>
                              <h6 class="mb-0">{{topStream.revenueStream}} ({{formatPrice(topStream.amountCollected)}})</h6>
                            </div>
                            <div class="col-md-3">
                              <small class="text-muted">Most Active Stream:</small>
                              <h6 class="mb-0">{{mostActiveStream.revenueStream}} ({{Number(mostActiveStream.totalTransactions).toLocaleString()}} transactions)</h6>
                            </div>
                            <div class="col-md-3">
                              <small class="text-muted">Average per Stream:</small>
                              <h6 class="mb-0">{{formatPrice(revenueStreams.length > 0 ? grandTotal / revenueStreams.length : 0)}}</h6>
                            </div>
                            <div class="col-md-3">
                              <small class="text-muted">Average per Transaction:</small>
                              <h6 class="mb-0">{{formatPrice(totalTransactions > 0 ? grandTotal / totalTransactions : 0)}}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Revenue Stream Performance Summary
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {biller, execute, execute2, getRight} from "@/api";
import moment from 'moment';
import ToolBarStreams from "@/components/reports/streams/ToolBar.vue";

export default {
  name: "ReportsStreams",
  components: {ToolBarStreams, NavigationBar},

  data() {
    return {
      loading: false,
      dateFrom: '',
      dateTo: '',
      maxDate: moment().format('YYYY-MM-DD'),
      dateRangeType: 'month',

      // Report data
      revenueStreams: [],
      totalTransactions: 0,
      totalUniqueAgents: 0,
      grandTotal: 0,

      // Location filters
      selectedSubCounty: '',
      selectedWard: '',
      selectedZone: '',
      subCounties: [],
      wards: [],
      zones: [],

      // Filtering and Sorting
      searchQuery: '',
      sortColumn: 'amountCollected',
      sortDirection: 'desc',

      // Pagination
      currentPage: 1,
      itemsPerPage: 100
    }
  },

  computed: {
    filteredWards() {
      if (!this.selectedSubCounty) {
        return this.wards;
      }
      return this.wards.filter(w => w.subCountyId === this.selectedSubCounty);
    },

    filteredZones() {
      if (!this.selectedWard) {
        return this.zones;
      }
      return this.zones.filter(z => z.wardId === this.selectedWard);
    },

    // Filter streams based on search query
    filteredStreams() {
      if (!this.searchQuery.trim()) {
        return this.revenueStreams;
      }

      const query = this.searchQuery.toLowerCase();
      return this.revenueStreams.filter(stream => {
        return stream.revenueStream.toLowerCase().includes(query) ||
            (stream.incomeTypePrefix && stream.incomeTypePrefix.toLowerCase().includes(query)) ||
            stream.totalTransactions.toString().includes(query) ||
            stream.totalAgents.toString().includes(query) ||
            this.formatPrice(stream.amountCollected).toLowerCase().includes(query);
      });
    },

    // Apply sorting to filtered results
    filteredAndSortedStreams() {
      const streams = [...this.filteredStreams];

      streams.sort((a, b) => {
        let aVal = a[this.sortColumn];
        let bVal = b[this.sortColumn];

        // Handle numeric values
        if (this.sortColumn === 'amountCollected') {
          aVal = parseFloat(aVal);
          bVal = parseFloat(bVal);
        } else if (this.sortColumn === 'totalTransactions' || this.sortColumn === 'totalAgents') {
          aVal = parseInt(aVal);
          bVal = parseInt(bVal);
        } else {
          // String comparison (case-insensitive)
          aVal = aVal ? aVal.toString().toLowerCase() : '';
          bVal = bVal ? bVal.toString().toLowerCase() : '';
        }

        if (this.sortDirection === 'asc') {
          return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
        } else {
          return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
        }
      });

      return streams;
    },

    // Paginated results
    paginatedStreams() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredAndSortedStreams.slice(start, end);
    },

    // Pagination calculations
    totalPages() {
      return Math.ceil(this.filteredAndSortedStreams.length / this.itemsPerPage);
    },

    displayedPages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    },

    // Calculate filtered totals
    filteredTotalTransactions() {
      return this.filteredStreams.reduce((sum, stream) => sum + parseInt(stream.totalTransactions || 0), 0);
    },

    filteredTotalAgents() {
      return this.filteredStreams.reduce((sum, stream) => sum + parseInt(stream.totalAgents || 0), 0);
    },

    filteredGrandTotal() {
      return this.filteredStreams.reduce((sum, stream) => sum + parseFloat(stream.amountCollected || 0), 0);
    },

    sortedStreams() {
      return [...this.revenueStreams].sort((a, b) =>
          parseFloat(b.amountCollected) - parseFloat(a.amountCollected)
      );
    },

    topStream() {
      if (this.revenueStreams.length === 0) {
        return { revenueStream: 'N/A', amountCollected: 0 };
      }
      return this.sortedStreams[0];
    },

    mostActiveStream() {
      if (this.revenueStreams.length === 0) {
        return { revenueStream: 'N/A', totalTransactions: 0 };
      }
      return [...this.revenueStreams].sort((a, b) =>
          parseInt(b.totalTransactions) - parseInt(a.totalTransactions)
      )[0];
    }
  },

  watch: {
    filteredAndSortedStreams() {
      this.currentPage = 1;
    }
  },

  mounted() {
    this.setDateRange('month');
    this.loadSubCountiesAndWards();
    this.menuAccess();
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Revenue Stream Summary");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    loadSubCountiesAndWards() {
      const data = new FormData();
      data.append("function", "getSubCounties");

      execute2(data, biller)
          .then((res) => {
            if (res.data.success) {
              const subCountiesData = res.data.data.subCounties || [];

              // Extract unique subcounties
              const uniqueSubCounties = {};
              subCountiesData.forEach(item => {
                if (!uniqueSubCounties[item.subCountyID]) {
                  uniqueSubCounties[item.subCountyID] = {
                    id: item.subCountyID,
                    name: item.subCountyName
                  };
                }
              });

              this.subCounties = Object.values(uniqueSubCounties);

              // Extract wards
              this.wards = subCountiesData.map(item => ({
                id: item.wardID,
                name: item.wardName,
                subCountyId: item.subCountyID
              }));
            }
          })
          .catch((err) => {
            console.error('Error loading subcounties and wards:', err);
          });
    },

    loadZones(subCountyID, wardID) {
      const data = new FormData();
      data.append("function", "getZones");
      if (subCountyID) {
        data.append("subCountyID", subCountyID);
      }
      if (wardID) {
        data.append("wardID", wardID);
      }

      execute2(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.zones = (res.data.data.zones || []).map(zone => ({
                id: zone.id,
                name: zone.zone,
                wardId: zone.wardID,
                subCountyId: zone.subCountyID
              }));
            } else {
              this.zones = [];
            }
          })
          .catch((err) => {
            console.error('Error loading zones:', err);
            this.zones = [];
          });
    },

    onSubCountyChange() {
      this.selectedWard = '';
      this.selectedZone = '';
      this.zones = [];
      if (this.selectedSubCounty) {
        this.loadZones(this.selectedSubCounty, null);
      }
      this.getRevenueData();
    },

    onWardChange() {
      this.selectedZone = '';
      if (this.selectedWard) {
        this.loadZones(this.selectedSubCounty, this.selectedWard);
      } else {
        this.zones = [];
      }
      this.getRevenueData();
    },

    onZoneChange() {
      this.getRevenueData();
    },

    clearLocationFilters() {
      this.selectedSubCounty = '';
      this.selectedWard = '';
      this.selectedZone = '';
      this.zones = [];
      this.getRevenueData();
    },

    getSubCountyName(id) {
      const sc = this.subCounties.find(s => s.id === id);
      return sc ? sc.name : id;
    },

    getWardName(id) {
      const ward = this.wards.find(w => w.id === id);
      return ward ? ward.name : id;
    },

    getZoneName(id) {
      const zone = this.zones.find(z => z.id === id);
      return zone ? zone.name : id;
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = column === 'revenueStream' ? 'asc' : 'desc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'bx-sort text-muted';
      }
      return this.sortDirection === 'asc' ? 'bx-sort-up text-primary' : 'bx-sort-down text-primary';
    },

    handleSearch() {
      this.currentPage = 1;
    },

    clearSearch() {
      this.searchQuery = '';
      this.currentPage = 1;
    },

    setDateRange(type) {
      this.dateRangeType = type;
      const now = moment();

      switch(type) {
        case 'today':
          this.dateFrom = now.format('YYYY-MM-DD');
          this.dateTo = now.format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'week':
          this.dateFrom = now.startOf('week').format('YYYY-MM-DD');
          this.dateTo = now.endOf('week').format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'month':
          this.dateFrom = now.startOf('month').format('YYYY-MM-DD');
          this.dateTo = now.clone().endOf('month').format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'year':
          this.dateFrom = now.startOf('year').format('YYYY-MM-DD');
          this.dateTo = now.endOf('year').format('YYYY-MM-DD');
          this.getRevenueData();
          break;
        case 'custom':
          if (!this.dateFrom || !this.dateTo) {
            this.dateFrom = now.startOf('month').format('YYYY-MM-DD');
            this.dateTo = now.clone().endOf('month').format('YYYY-MM-DD');
          }
          break;
      }
    },

    refreshData() {
      this.getRevenueData();
    },

    getRevenueData() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getRevenueStreamSummary");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      if (this.selectedSubCounty) {
        data.append("subCountyID", this.selectedSubCounty);
      }

      if (this.selectedWard) {
        data.append("wardID", this.selectedWard);
      }

      if (this.selectedZone) {
        // Pass zone name, not ID (transactions table stores zone name)
        const zoneName = this.getZoneName(this.selectedZone);
        data.append("zone", zoneName);
      }

      execute2(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              const reportData = res.data.data.data;
              this.revenueStreams = reportData.revenueStreams || [];
              this.totalTransactions = reportData.totalTransactions || 0;
              this.totalUniqueAgents = reportData.totalUniqueAgents || 0;
              this.grandTotal = reportData.grandTotal || 0;

              this.currentPage = 1;
              this.searchQuery = '';
            } else {
              // Clear data on error
              this.revenueStreams = [];
              this.totalTransactions = 0;
              this.totalUniqueAgents = 0;
              this.grandTotal = 0;
              console.error('API Error:', res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            // Clear data on error
            this.revenueStreams = [];
            this.totalTransactions = 0;
            this.totalUniqueAgents = 0;
            this.grandTotal = 0;
            console.error('Error loading revenue data:', e);
          });
    },

    getStreamIcon(stream) {
      const icons = {
        'PARKING': 'bx bx-car',
        'MARKETS': 'bx bx-store',
        'BUS PARK': 'bx bx-bus',
        'LAND RATES': 'bx bx-home',
        'SBP': 'bx bx-briefcase',
        'CESS': 'bx bx-package',
        'ADVERTS AND BILLBOARDS': 'bx bx-image',
        'BUILDING PLANS': 'bx bx-building',
        'PARK FEES': 'bx bx-tree',
        'PHYSICAL PLANNING SERVICES': 'bx bx-map-alt',
        'Uninvoiced Payments': 'bx bx-question-mark'
      };
      return icons[stream] || 'bx bx-receipt';
    },

    getStreamColor(stream) {
      const colors = {
        'PARKING': 'bg-soft-primary text-primary',
        'MARKETS': 'bg-soft-success text-success',
        'BUS PARK': 'bg-soft-info text-info',
        'LAND RATES': 'bg-soft-warning text-warning',
        'SBP': 'bg-soft-danger text-danger',
        'Uninvoiced Payments': 'bg-soft-dark text-dark'
      };
      return colors[stream] || 'bg-soft-secondary text-secondary';
    },

    viewDetails(route, item, amountCollected) {
      const incomeTypePrefix = item.incomeTypePrefix || "NULL";

      sessionStorage.setItem("currentPage", route);
      sessionStorage.setItem("dateTo", this.dateTo);
      sessionStorage.setItem("dateFrom", this.dateFrom);
      sessionStorage.setItem("revenueStreamName", item.revenueStream);
      sessionStorage.setItem("subCountyName", "");
      sessionStorage.setItem("subCountyID", "");
      sessionStorage.setItem("incomeTypeDescription", "");
      sessionStorage.setItem("feeDescription", "");
      sessionStorage.setItem("incomeTypePrefix", incomeTypePrefix);
      sessionStorage.setItem("amountCollected", amountCollected);

      router.push(route);
    },

    downloadCSV() {
      const dataToExport = this.searchQuery ? this.filteredAndSortedStreams : this.sortedStreams;

      if (dataToExport.length === 0) {
        alert('No data available to download');
        return;
      }

      const headers = ['#', 'Revenue Stream', 'Income Type Prefix', 'Total Transactions', 'Total Agents', 'Amount Collected'];
      const rows = [];

      // Add metadata
      rows.push('COUNTY REVENUE SYSTEM - REVENUE STREAM SUMMARY REPORT');
      rows.push('');
      rows.push(`Date Range:,"${moment(this.dateFrom).format('DD/MM/YYYY')} to ${moment(this.dateTo).format('DD/MM/YYYY')}"`);

      if (this.selectedSubCounty) {
        rows.push(`Sub County Filter:,"${this.getSubCountyName(this.selectedSubCounty)}"`);
      }
      if (this.selectedWard) {
        rows.push(`Ward Filter:,"${this.getWardName(this.selectedWard)}"`);
      }
      if (this.selectedZone) {
        rows.push(`Zone Filter:,"${this.getZoneName(this.selectedZone)}"`);
      }
      if (this.searchQuery) {
        rows.push(`Search Filter:,"${this.searchQuery}"`);
      }

      rows.push('');
      rows.push('SUMMARY TOTALS');
      rows.push(`Total Revenue:,${this.formatPrice(this.filteredGrandTotal)}`);
      rows.push(`Total Transactions:,${this.filteredTotalTransactions.toLocaleString()}`);
      rows.push(`Total Agents:,${this.filteredTotalAgents}`);
      rows.push(`Revenue Streams:,${dataToExport.length}`);
      rows.push('');
      rows.push('');

      // Add headers
      rows.push(headers.join(','));

      // Add data
      dataToExport.forEach((stream, index) => {
        const row = [
          index + 1,
          `"${stream.revenueStream.replace(/"/g, '""')}"`,
          `"${(stream.incomeTypePrefix || 'N/A').replace(/"/g, '""')}"`,
          stream.totalTransactions,
          stream.totalAgents,
          stream.amountCollected
        ];
        rows.push(row.join(','));
      });

      // Add totals
      rows.push('');
      rows.push(['', '"TOTALS"', '""', this.filteredTotalTransactions, this.filteredTotalAgents, this.filteredGrandTotal].join(','));

      rows.push('');
      rows.push('PERFORMANCE INSIGHTS');
      rows.push(`Top Revenue Stream:,"${this.topStream.revenueStream}",${this.topStream.amountCollected}`);
      rows.push(`Most Active Stream:,"${this.mostActiveStream.revenueStream}",${this.mostActiveStream.totalTransactions}`);
      rows.push(`Average per Stream:,${this.revenueStreams.length > 0 ? this.grandTotal / this.revenueStreams.length : 0}`);
      rows.push(`Average per Transaction:,${this.totalTransactions > 0 ? this.grandTotal / this.totalTransactions : 0}`);
      rows.push('');
      rows.push(`Report Generated:,"${moment().format('DD/MM/YYYY HH:mm:ss')}"`);
      rows.push(`Generated By:,"${sessionStorage.getItem('sessionNames') || 'System'}"`);

      const csvContent = rows.join('\n');
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      let filename = `revenue_stream_summary_${this.dateFrom}_to_${this.dateTo}`;
      if (this.selectedSubCounty) filename += `_${this.getSubCountyName(this.selectedSubCounty).replace(/\s+/g, '_')}`;
      if (this.selectedWard) filename += `_${this.getWardName(this.selectedWard).replace(/\s+/g, '_')}`;
      if (this.selectedZone) filename += `_${this.getZoneName(this.selectedZone).replace(/\s+/g, '_')}`;
      filename += '.csv';

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(link.href);
      }, 100);
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },

    moment(date) {
      return moment(date);
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.bg-soft-primary {
  background-color: rgba(50, 149, 239, 0.1);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
}

.bg-soft-warning {
  background-color: rgba(244, 206, 109, 0.1);
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
}

.bg-soft-secondary {
  background-color: rgba(133, 146, 163, 0.1);
}

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.1);
}

.table-warning {
  background-color: rgba(255, 193, 7, 0.05) !important;
}

.sortable-header {
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #212529 !important;
}

.sortable-header i {
  font-size: 0.875rem;
  vertical-align: middle;
}

.input-group-text {
  background-color: #f8f9fa;
  border-right: none;
}

.input-group .form-control {
  border-left: none;
}

.input-group .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  color: #495057;
  border: 1px solid #dee2e6;
}

.page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.dataTables_info {
  padding-top: 0.85rem;
  color: #6c757d;
}

.badge {
  font-weight: 500;
}
</style>